<template>
  <div>
    <div id="loading" v-show="loading"  style="z-index: 1000 ;position:fixed;height: 600px" >
      <div class="loading"  v-loading="loading" element-loading-background="rgba(255, 255, 255, 0.8)">
        正在上传视频....请耐心等待，成功后继续答题！
      </div>
    </div>
    <van-cell-group v-if="iswx">
      <van-uploader :after-read="uploadImg"
                    deletable @delete="delImg(0)" capture="environment"
                    :accept="accept"
                    v-model="value"
                    :max-count="max_count" :max-size="60000000000" upload-text="上传视频"></van-uploader>
    </van-cell-group>
    <div class="imgbox" v-if="!iswx">
      <div v-for="(img, k) in value" :key="k" class="imgAll">
        <img :src="img.img_url" />
        <span class="delImg" @click="delImg(k)">+</span>
      </div>
      <div v-if="max_count==1" class="imgAll" @click="upvideo" style="background-color: rgb(236, 236, 236);"><van-icon class="cimg" size="20" name="video"></van-icon></div>
    </div>
    <van-overlay :show="show" z-index="999999999">
      <div class="wrapper">
        <van-loading text-color="#0094ff" >{{'上传中...'}}</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
  export default {
    model:{
      prop:'value',
      event:'load'
    },
    data(){
      return{
        loading: false,
        iswx: false,
        show:false
      }
    },
    props: {
      url: String,
      geturlbyid:String,
      w: {
        type: Number,
        default: 400
      },
      h: {
        type: Number,
        default: 300
      },
      transshape:{
        type:Boolean,
        default:false
      },
      quality: {
        type: Number,
        default: 0.5
      },
      max_count: {
        type: Number,
        default: 1
      },
      accept: {
        type: String,
        default:"video/*"
      },
      value:Array
    },
    created() {
      //用来判断是app应用还是h5应用，如果是h5应用设置iswx=true
      try {
        this.$jtp('checkApp', "iswx",);
      }catch (e) {
        this.iswx=true;
      }
      if(!this.iswx){
      this.max_count=this.max_count+this.value.length;
      }
    },
    methods: {
      uploadImg(file) {
        this.show =true;
        let that = this;
        let index=this.value.length-1;
        if (this.url != undefined && this.url != '' ) {
          this.value[index].status="uploading"
          this.value[index].message = "上传中..."
          that.loading = true;
          //上传后端备齐一个上传表？还是答案提交采取单题模式？
          let data = new FormData();
          data.append('file', file.file);
          let z=this.value[index];
          let v=this.value;
          this.$ajax.post(this.url, data).then(function(res){
            if(res.code==200){
              z.status='';
              z.message='正在加载...';
              z.content = file.file.type;
              z.url= res.picUrl;
              that.$emit('load',v);
              //将图片保存到rides
              that.$emit('saveanswer');
              that.loading = false;
              that.show=false;
            }
          });
        }
      },
      delImg(index) {
        this.value.splice(index, 1);
        //将图片保存到rides
        this.$emit('saveanswer');
        this.$emit('load', this.value);

        if(this.max_count>1)
        {
          this.max_count=1;
        }
      },
      //app应用调用上传
      upvideo() {
       this.$jtp('openMediaRecorder', this.$global.upvideopath+this.url+"^"+localStorage.getItem('Token'), this.afterup);
      },
      afterup(res) {
        if (res != 0 || res != '0') {
          let x = res.indexOf('|');
          this.max_count++;
          this.value.push({url: res.substring(0, x),content:'video/mp4', img_url: res.substring(x + 1)});
          this.$emit('saveanswer');
        }
      }
    },

  };
</script>

<style >
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .imgbox {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
  }
  .imgbox img {
    width: 100px;
    height: 100px;
  }

  .imgAll {
    /*图片容器position: relative属性*/
    width: 100px;
    height: 100px;
    border: solid 1px #ccc;
    margin: 8px 5px;
    float: left;
    position: relative;
    cursor: pointer;
    box-shadow: 0 0 10px #eee;
  }
  .cimg {
    position: absolute;
    top: 40px;
    left: 40px;
    width: 20px;
    height: 20px;
  }
  .delImg {
    position: absolute;
    top: -10px;
    right: -7px;
    width: 22px;
    height: 22px;
    background: #151718;
    border-radius: 50%;
    display: block;
    text-align: center;
    line-height: 22px;
    color: #fff;
    font-weight: 700;
    font-style: normal;
    cursor: pointer;
    /* Rotate div */
    transform: rotate(45deg);
    -ms-transform: rotate(45deg); /* Internet Explorer */
    -moz-transform: rotate(45deg); /* Firefox */
    -webkit-transform: rotate(45deg); /* Safari 和 Chrome */
    -o-transform: rotate(45deg); /* Opera */
  }
</style>



// WEBPACK FOOTER //
// src/components/common/videopay.vue